import { useEffect, useState } from "react";

// Persiste o objeto de filtros em localStorage por chave, para sobreviver entre navegações.
// `camposNaoPersistidos` lista campos que nunca são gravados nem lidos (sempre voltam ao valor inicial).
export function useFiltrosPersistidos(chave, valorInicial = {}, camposNaoPersistidos = []) {
    const [filtros, setFiltros] = useState(() => {
        try {
            const salvo = localStorage.getItem(chave);
            if (!salvo) return valorInicial;
            const lido = { ...JSON.parse(salvo) };
            camposNaoPersistidos.forEach(campo => delete lido[campo]);
            return { ...valorInicial, ...lido };
        } catch {
            return valorInicial;
        }
    });

    useEffect(() => {
        try {
            const paraSalvar = { ...filtros };
            camposNaoPersistidos.forEach(campo => delete paraSalvar[campo]);
            localStorage.setItem(chave, JSON.stringify(paraSalvar));
        } catch {
            // localStorage indisponível (modo privado etc.) — segue sem persistir
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chave, filtros]);

    function limparFiltros() {
        setFiltros(valorInicial);
    }

    return [filtros, setFiltros, limparFiltros];
}
